import { render } from "./Support.vue?vue&type=template&id=422d1201&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "@/assets/scss/_faq.scss?vue&type=style&index=0&id=422d1201&lang=scss&scoped=true"
import "./custom-support.scss?vue&type=style&index=1&id=422d1201&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422d1201"]])

export default __exports__